<template>
  <div>
    <SectionHeader
      v-show="collectionCards.length"
      class="mx-1"
      style="margin-bottom: 6px"
      :title="sectionHeaderTitle"
      :has-border-top="headerHasBorderTop"
      :title-lg="true"
    ></SectionHeader>
    <div class="subtype-card--grid-wrapper">
      <div class="grid-card--gap"></div>
      <router-link
        :style="{ 'grid-template-rows: ' : showExplanation ? '102px' : '102px 36px'}"
        :to="{name: 'events', params: {cityName: $store.state.user.userCity,slug: eventType}, query: { subtype: item.data.subtype} }"
        class="subtype-card"
        v-for="item in collectionCards"
        :key="item.id"
      >
        <figure class="image is-3by1">
          <img lazy="loaded" v-lazy="item.data.cardPhotoURLs.sm.url" :alt="item.data.title.tr" />
          <!-- <div class="subtype-card--content has-text-white px-1" style="padding-top: 12px"></div> -->
          <div
            style="line-height: 1.2; text-shadow: 1px 1px 7px grey; position:absolute; top: 0; left: 0; bottom: 0; width: 100%; display: inline-flex; justify-content: center; align-items: center"
          >
            <p
              class="px-1 is-size-5  has-text-centered has-text-weight-semibold has-text-white"
            >{{ item.data.title.tr }}</p>
          </div>
        </figure>

        <div class="has-text-black-ter" style="padding-left: 6px" v-show="showExplanation">
          <p
            class="has-text-weight-normal is-size-14px"
            style="margin-top: 0px; line-height: 1.35"
          >{{ $options.filters.truncate(item.data.summary.tr, 42) }}</p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import SectionHeader from "@/components/shared/SectionHeader";
export default {
  name: "subtype-cardrail",
  components: { SectionHeader },
  props: {
    collectionName: {
      type: String,
      required: true
    },
    eventType: {
      type: String,
      required: true
    },
    sectionHeaderTitle: {
      type: String,
      default: ""
    },
    headerHasBorderTop: {
      type: Boolean,
      default: true
    },
    showExplanation: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      collectionCards: []
    };
  },
  created() {
    this.fetchCollectionCards();
  },
  methods: {
    subtypes(arr) {
      let res = "";

      arr.forEach((item, ind) => {
        res = res.concat(
          this.$options.filters.capitalize(this.$t(`evType.${item}`))
        );
        if (arr.length - 1 !== ind) res = res.concat(", ");
      });
      return res;

      // item.data.subtypes.join(', ') | capitalize
    },
    async fetchCollectionCards() {
      try {
        const cards = await this.$store.dispatch(
          "appData/fetchCollectionCard",
          { collectionName: this.collectionName }
        );
        this.collectionCards = cards.sort(() => 0.5 - Math.random());

      } catch (error) {
        if (process.env.NODE_ENV === "development") {
          console.log(error);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.subtype-card--grid-wrapper {
  padding-bottom: 2px;
  width: 100%;
  display: grid;
  grid-template-columns: 8px repeat(6, minmax(52%, 1fr));
  grid-column-gap:  8px;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  -webkit-scroll-snap-type: mandatory;
  -webkit-scroll-snap-destination: 50% 50%;
  scroll-padding-left: 16px;
}

.subtype-card {
  -webkit-scroll-snap-coordinate: 50% 50%;
  scroll-snap-align: start;
  display: inline-grid;
  // grid-template-rows: 112px 36px;
  grid-row-gap: 6px;
  // margin-top: 6px;

  figure {
    // margin-left: 4px;
    // margin-right: 4px;
    overflow: hidden;
    border-radius: 8px;
    max-height: 102px;
    height: 102px;
  }
  &:first-child {
    margin-left: 10px;
  }
  &:last-child {
    figure {
      margin-right: 16px;
    }
  }
}
</style>